var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 54,
    viewBox: "0 0 51 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6645 37.8633L34.9814 46.5198C33.8689 47.6283 32.3702 48.247 30.7995 48.247H7.92264C4.65231 48.247 2 45.5918 2 42.3179V7.9291C2 4.65521 4.65231 2 7.92264 2H39.4826C42.7529 2 45.4052 4.65521 45.4052 7.9291V33.6614C45.4103 35.2391 44.782 36.7497 43.6645 37.8633Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9281 43.3956L40.245 52.0521C39.1326 53.1606 37.6339 53.7792 36.0631 53.7792H13.1914C9.92111 53.7792 7.2688 51.124 7.2688 47.8501V13.4613C7.2688 10.1874 9.92111 7.53223 13.1914 7.53223H44.7514C48.0217 7.53223 50.674 10.1874 50.674 13.4613V39.1936C50.674 40.7713 50.0457 42.2819 48.9281 43.3956Z",
    fill: "#FCC240"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7258 21.5497C15.7258 20.9063 16.2474 20.3848 16.8908 20.3848H41.7427C42.386 20.3848 42.9076 20.9063 42.9076 21.5497C42.9076 22.1931 42.386 22.7146 41.7427 22.7146H16.8908C16.2474 22.7146 15.7258 22.1931 15.7258 21.5497Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7258 26.9862C15.7258 26.3428 16.2474 25.8213 16.8908 25.8213H41.7427C42.386 25.8213 42.9076 26.3428 42.9076 26.9862C42.9076 27.6296 42.386 28.1512 41.7427 28.1512H16.8908C16.2474 28.1512 15.7258 27.6296 15.7258 26.9862Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7258 32.4218C15.7258 31.7784 16.2474 31.2568 16.8908 31.2568H41.7427C42.386 31.2568 42.9076 31.7784 42.9076 32.4218C42.9076 33.0651 42.386 33.5867 41.7427 33.5867H16.8908C16.2474 33.5867 15.7258 33.0651 15.7258 32.4218Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7258 37.8583C15.7258 37.2149 16.2474 36.6934 16.8908 36.6934H29.3167C29.9601 36.6934 30.4816 37.2149 30.4816 37.8583C30.4816 38.5017 29.9601 39.0232 29.3167 39.0232H16.8908C16.2474 39.0232 15.7258 38.5017 15.7258 37.8583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.7322d387d1fa92f0d608bce7dd288731.svg";
export { ForwardRef as ReactComponent };